import { render, staticRenderFns } from "./patientInvoices.vue?vue&type=template&id=1133ba10&scoped=true"
import script from "./patientInvoices.vue?vue&type=script&lang=js"
export * from "./patientInvoices.vue?vue&type=script&lang=js"
import style0 from "./patientInvoices.vue?vue&type=style&index=0&id=1133ba10&prod&lang=scss&scoped=true"
import style1 from "./patientInvoices.vue?vue&type=style&index=1&id=1133ba10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1133ba10",
  null
  
)

export default component.exports